export default "__VITE_ASSET__eavGPaba__"